import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Card,
  Column,
  Columns,
  NumberInput,
  TextInput,
} from '@resurs/midas-react'
import { colors, midas } from '@resurs/midas'
import { format } from '../../../../models/format'
import { getText } from '../../../../internal/TextLabels'
import { classNames, parseUnitPriceExVat } from '../../../../util/helpers'

class TransactionAddArticleUI extends React.PureComponent {
  render() {
    return (
      <Card title={getText('transactions.transaction.add.title')}>
        <Columns>
          <Column col5>
            <form
              id="addArticle"
              onSubmit={e => {
                e.preventDefault()
                this.props.handleAdd(this.props.article)
              }}
            >
              <TextInput
                type="text"
                label={getText('transactions.transaction.headers.article')}
                id="reference"
                value={this.props.article.reference}
                onChange={e =>
                  this.props.handleInputChange(e.target.value, 'reference')
                }
                format={format.shortString}
                required={getText(
                  'transactions.transaction.specification.requiredError',
                )}
                dataCy="add-article-nbr"
              />
              <div style={{ height: '.5rem' }} />
              <TextInput
                type="text"
                label={getText('transactions.transaction.headers.description')}
                id="description"
                value={this.props.article.description}
                onChange={e =>
                  this.props.handleInputChange(e.target.value, 'description')
                }
                format={format.string}
                required={getText(
                  'transactions.transaction.specification.requiredError',
                )}
                dataCy="add-article-description"
              />
              <div style={{ height: '.5rem' }} />
              <NumberInput
                allowNegative
                label={getText(
                  'transactions.transaction.headers.unitPriceExVat',
                )}
                id="unitPriceExVat"
                value={`${this.props.article.unitPriceExVat || ''}`}
                onChange={number =>
                  this.props.handleInputChange(
                    parseUnitPriceExVat(number),
                    'unitPriceExVat',
                  )
                }
                format={format.float}
                required={getText(
                  'transactions.transaction.specification.requiredError',
                )}
                dataCy="add-article-unit-price"
              />
              <div style={{ height: '.5rem' }} />
              <NumberInput
                label={getText('transactions.transaction.headers.vat')}
                id="vatRate"
                value={
                  this.props.article.vatRate
                    ? `${this.props.article.vatRate}`
                    : ''
                }
                onChange={number =>
                  this.props.handleInputChange(number, 'vatRate')
                }
                format={format.integer}
                required={getText(
                  'transactions.transaction.specification.requiredError',
                )}
                dataCy="add-article-vat"
              />
              <div style={{ height: '.5rem' }} />
              <NumberInput
                label={getText('transactions.transaction.headers.quantity')}
                id="quantity"
                value={
                  this.props.article.quantity
                    ? `${this.props.article.quantity}`
                    : ''
                }
                onChange={number =>
                  this.props.handleInputChange(number, 'quantity')
                }
                allowNegative
                format={format.negativeOrPositiveNumbers}
                required={getText(
                  'transactions.transaction.specification.requiredError',
                )}
                dataCy="add-article-quantity"
              />
              <div style={{ height: '.5rem' }} />
              <TextInput
                type="text"
                label={getText('transactions.transaction.headers.unit')}
                id="unit"
                value={this.props.article.unit}
                onChange={e =>
                  this.props.handleInputChange(e.target.value, 'unit')
                }
                format={format.shortString}
                required={getText(
                  'transactions.transaction.specification.requiredError',
                )}
                dataCy="add-article-unit"
              />
              <Column col12>
                <div className={midas.hasDanger}>
                  {!this.props.isSumValid && (
                    <p className={midas.formInputHint}>
                      {getText('transactions.transaction.add.errorMessage')}
                    </p>
                  )}
                </div>
              </Column>
              <div style={{ display: 'flex', gap: '.9rem' }}>
                <Button
                  type="normal"
                  text={getText('default.cancel')}
                  onClick={e => {
                    e.preventDefault()
                    this.props.toggleAddArticle(false)
                  }}
                />
                <Button
                  disabled={
                    !this.props.isSumValid ||
                    !this.props.isFormValid ||
                    this.props.loading
                  }
                  loading={this.props.loading}
                  type="primary"
                  form
                  text={getText('default.add')}
                  dataCy="add-article-add-button"
                />
              </div>
            </form>
          </Column>
          <Column col1>
            {' '}
            <div
              style={{
                paddingTop: '4.7rem',
                color: colors.blue,
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <i className={classNames(midas.icon, midas.midasArrow31)} />
            </div>
          </Column>
          <Column col4>
            <Column col12>
              <span>{`${getText(
                'transactions.transaction.add.subTitle',
              )} (${getText(
                'default.currency',
                Number(this.props.orderLimit).toLocaleString('sv-SE', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }),
              )})`}</span>
            </Column>
            <Column col12>
              <strong>{getText('transactions.transaction.add.newSum')}</strong>
              {getText(
                'default.currency',
                Number(
                  this.props.newOrderSum + this.props.currentOrderSum,
                ).toLocaleString('sv-SE', {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                }),
              )}
            </Column>
          </Column>
        </Columns>
      </Card>
    )
  }
}

TransactionAddArticleUI.propTypes = {
  isSumValid: PropTypes.bool.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  newOrderSum: PropTypes.number.isRequired,
  orderLimit: PropTypes.number.isRequired,
  currentOrderSum: PropTypes.number.isRequired,
  article: PropTypes.object.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  toggleAddArticle: PropTypes.func.isRequired,
}

export default TransactionAddArticleUI
